import React, { FC, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ThunkGetTicket } from 'store/tickets/thunks';
import { TicketSelector } from 'store/tickets/selectors';

import Loader from '../../components/Loader';
import TicketDetails from 'pages/Teams/components/TicketDetails';

import useStyles from './styles';

const Ticket: FC = () => {
  const [loading, setLoading] = useState<boolean>(true);

  const { ticketId } = useParams();
  const dispatch = useAppDispatch();
  const ticket = useAppSelector(TicketSelector);
  const classes = useStyles();

  const onMount = useCallback(() => {
    if (ticketId) {
      setLoading(true);
      dispatch(ThunkGetTicket({ ticketId }))
        .unwrap()
        .finally(() => {
          setLoading(false);
        });
    }
  }, [ticketId, dispatch]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  if (loading) return <Loader />;
  return (
    <div className={classes.ticket}>
      <TicketDetails ticketId={ticket?.id ?? ''} />
    </div>
  );
};

export default Ticket;
